<template>
  <div  :class="`d-flex justify-space-around`">
    <v-spacer></v-spacer>
    <v-text-field
      v-model="pw"
      outlined
      dense
      required
      prepend-inner-icon="mdi-lock-question"
      placeholder="Password"
      :rules="pwRules"
      hint="Your Password"
      :append-icon="eyevaluepw ? 'mdi-eye' : 'mdi-eye-off'"
      @click:append="() => (eyevaluepw = !eyevaluepw)"
      @input="pw_changed"
      :type="eyevaluepw ? 'password' : 'text'"
    ></v-text-field>
    <v-spacer></v-spacer>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Pw",
  // regid: Number,
  data() {
    return {
      // pw: String,
      eyevaluepw: true,
      pwRules: [(v) => !!v || "Password is required"],
      model: null,
      pw: String
    };
  },
  created() {
    this.pw = null;
  },
  methods: {
    clear() {
      this.model = null;
      this.$emit("pw_changed", this.pw);
    },
    pw_changed() {
      //this.pw = value;
      this.$emit("pw_changed", this.pw);
    }
  },
  computed: {
    fields() {
      if (!this.model) return [];

      return Object.keys(this.model).map((key) => {
        // console.log('regId',key)
        console.log("value", this.model[key]);
        this.$emit("pw", this.model[key]);
        return {
          key,
          value: this.model[key] || "n/a",
        };
      });
    },
  },
};
</script>